export default __webpack_public_path__ + "static/media/EngineeringDams_01.73029ae6.png";